module.exports = __webpack_public_path__ + "static/media/we-create.e47d9ca9.png";